import {
    createAction,
    createSlice
} from '@reduxjs/toolkit';
import { APIConnectionFirmsRecord, CoreMsgTypes } from '@tassat/fred-definitions';

export interface APIConnectionFirmsState {
    [key: string]: APIConnectionFirmsRecord;
}

const initialState: APIConnectionFirmsState = {};

const initialLoadAction = createAction<{ apiconnectionfirms: {
    [apiConnectionId: string]: APIConnectionFirmsRecord;
}; }>('InitialLoad');
const setApiConnectionFirmAction = createAction<APIConnectionFirmsRecord[]>('SET_API_CONNECTION_FIRMS');
const apiConnectionFirmRecordAction = createAction<APIConnectionFirmsRecord>(CoreMsgTypes.APIConnectionFirmsRecord);

const apiConnectionFirmsSlice = createSlice({
    name: 'apiConnectionFirms',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(initialLoadAction, (_state, action) => action.payload.apiconnectionfirms)
            .addCase(setApiConnectionFirmAction, (state, action) => {
                const mappedApiConnectionFirms = {};
                action.payload.forEach((apiConnectionFirm) => {
                    mappedApiConnectionFirms[apiConnectionFirm.APIConnectionFirmId] = apiConnectionFirm;
                });

                return {
                    ...state,
                    ...mappedApiConnectionFirms
                };
            })
            .addCase(apiConnectionFirmRecordAction, (state, action) => {
                state[action.payload.APIConnectionFirmId] = action.payload;
            })
            .addDefaultCase((state) => state);
    }
});

export default apiConnectionFirmsSlice.reducer;